import React from 'react';
import { Tooltip } from 'antd';
import moment from 'moment';
import DateCellContent from '../../../../../shared/ui/DateCellContent/DateCellContent';
import {
  modalActionTypes,
  modalTypes,
  useModalDispatch,
} from '../../../../../shared/lib/toggleModalVisble';
import { useShutdownAccesses } from '../../../../../shared/lib/hooks/useShutdownAccesses';
import ShutdownTag from '../../../../../shared/ui/ShutdownTag/ShutdownTag';
import styles from './Content.module.scss';

const Cell = ({ shutdown, tooltipTitle, onClick }) => {
  const { startDate: start, endDate: end } = shutdown || {};

  const startDate = start ? moment(start) : undefined;
  const endDate = end ? moment(end) : undefined;

  const hasStartDate = Boolean(startDate?.isValid());
  const hasEndDate = Boolean(endDate?.isValid());

  const mainContent = (
    <Tooltip
      title={tooltipTitle || ''}
      placement="topLeft"
    >
      <DateCellContent
        onClick={onClick}
        date={hasEndDate ? endDate : undefined}
      />
    </Tooltip>
  );

  return hasStartDate && hasEndDate ? (
    <div className={styles.container}>
      <div>{mainContent}</div>
      <ShutdownTag
        content={`${endDate.diff(startDate, 'hours')} ч.`}
        tooltipTitle="Фактическая продолжительность"
      />
    </div>
  ) : (
    mainContent
  );
};

const ActiveDate = ({ shutdown }) => {
  const dispatch = useModalDispatch();

  const handleClick = (e) => {
    e.stopPropagation();

    dispatch({
      type: modalActionTypes.setModalData,
      payload: {
        type: modalTypes.changeShutdownEndDate,
        initialValues: shutdown,
      },
    });
  };

  return (
    <Cell
      shutdown={shutdown}
      tooltipTitle={
        shutdown.endDate ? 'Изменить дату окончания' : 'Добавить дату окончания'
      }
      onClick={handleClick}
    />
  );
};

const Content = ({ shutdown }) => {
  const { canChange } = useShutdownAccesses();

  if (!canChange) {
    return <Cell shutdown={shutdown} />;
  }

  return <ActiveDate shutdown={shutdown} />;
};

export default Content;
